module.exports = __webpack_public_path__ + "img/explosion-particle.7f0300ff.png";